<template>
  <kst-section items-mode class="mt-5">
    <kst-table input-mode :data="items">
      <b-table-column
        v-slot="{ column, row }"
        field="DispatchID"
        :label="StockTrfItemCatalog.DispatchID.ColumnLabel"
      >
        <kst-output field-only
          :field="column.field" :data="row" :catalog="StockTrfItemCatalog"
        />
      </b-table-column>

      <b-table-column cell-class="ks-col-nopad" header-class="p-0" width="1">
        <template #header>
          <kst-header-blank />
        </template>
        <template #default="{ row }">
          <kst-tooltip info-mode>
            <template #content>
              <kst-list info-mode :items="Model.Details.getItemInfo(row)"/>
            </template>
            <kst-icon info-mode/>
          </kst-tooltip>
        </template>
      </b-table-column>

      <b-table-column
        v-slot="{ column, row }"
        field="Packaging"
        :label="StockTrfItemCatalog.Packaging.Label"
      >
        <kst-output field-only
          :field="column.field" :data="row" :catalog="StockTrfItemCatalog"
        />
      </b-table-column>

      <b-table-column
        v-slot="{ column, row }"
        field="Qty"
        :label="StockTrfItemCatalog.Qty.Label"
      >
        <kst-output field-only
          :field="column.field" :data="row" :catalog="StockTrfItemCatalog"
        />
      </b-table-column>

      <template v-if="access.Glob_HPP">
        <b-table-column numeric
          v-slot="{ column, row }"
          field="HppTotal"
          :label="StockTrfItemCatalog.HppTotal.Label"
        >
          <kst-output box-off field-only
            :field="column.field" :data="row" :catalog="StockTrfItemCatalog"
          />
        </b-table-column>
      </template>
    </kst-table>
  </kst-section>
</template>

<script>
import StockTrfItemCatalog from "../SttrItemCatalog.js";
import Model from "../SttrModel.js";

export default {
  props: {
    access: Object,
    items: Array
  },
  data: () => ({
    StockTrfItemCatalog: StockTrfItemCatalog,
    Model: Model
  })
}
</script>